import React from "react";
import "../App.css";

const STEPS = [
  {
    number: "01",
    title: "Diagnóstico das necessidades da empresa",
    text: "Analisamos as necessidades específicas da sua empresa para identificar oportunidades de otimização e conformidade.",
  },
  {
    number: "02",
    title: "Planejamento e organização dos processos",
    text: "Desenvolvemos um plano de ação personalizado, organizando processos e definindo estratégias fiscais e contábeis.",
  },
  {
    number: "03",
    title: "Execução das rotinas contábeis, fiscais e legais",
    text: "Realizamos todas as rotinas contábeis, fiscais e legais com precisão e agilidade, garantindo a regularidade do seu negócio.",
  },
  {
    number: "04",
    title: "Acompanhamento contínuo e suporte consultivo",
    text: "Oferecemos suporte consultivo contínuo, monitorando resultados e adaptando estratégias para seu crescimento.",
  },
];

export default function Methodology() {
  return (
    <section className="methodology">
      <div className="methodology__blob" aria-hidden="true" />

      <div className="methodology__container">
        <span className="methodology__label">Nossa Metodologia</span>
        <h2 className="methodology__title">Como Trabalhamos</h2>

        <div className="methodology__grid">
          {STEPS.map((step, index) => (
            <div key={step.number} className="methodology__step" style={{ "--step-index": index }}>
              <span className="methodology__step-number">{step.number}</span>
              {index < STEPS.length - 1 && (
                <span className="methodology__step-arrow" aria-hidden="true">›</span>
              )}
              <h3 className="methodology__step-title">{step.title}</h3>
              <p className="methodology__step-text">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
